/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import AnalysisTypeSelector from './AnalysisTypeSelector/index'
import AnalyzeAction from './AnalyzeAction/index'
import CalibrateImageAction from './CalibrateImageAction/index'
import CalibrationTool from './CalibrationTool/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/PerformTrace/Content/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AnalysisTypeSelector
  viewPath={`${viewPath}/AnalysisTypeSelector`}
/>
<CalibrateImageAction
  viewPath={`${viewPath}/CalibrateImageAction`}
/>
<AnalyzeAction
  viewPath={`${viewPath}/AnalyzeAction`}
/>
</div>
<CalibrationTool
  viewPath={`${viewPath}/CalibrationTool`}
/>
{children}
</React.Fragment>)
}